module.exports = __webpack_public_path__ + "static/DUC_7865-01-7a4356fafd2c4b854807200d4835dc12.jpeg";